import { SeatType } from '@vista-digital/ocapi-types/v1';
import { SeatPickerScreenPosition } from '../types/config/screen-position';
import { getMapDimension } from './map';
/**
 * Returns the SVG rectangle of a seat.
 */
export function getSeatRectangle(seatType, seatPosition, area, scaleFactor, config) {
    const dimensions = getSeatDimensions(area, seatType, scaleFactor, config);
    const coordinates = getSeatCoordinates(area, seatType, seatPosition, scaleFactor, config);
    return Object.assign(Object.assign({}, dimensions), coordinates);
}
/**
 * Returns the dimensions of a seat in SVG units.
 */
function getSeatDimensions(area, type, scaleFactor, config) {
    const width = area.boundary.right - area.boundary.left;
    const widthPercentage = width / area.columnCount;
    const height = area.boundary.bottom - area.boundary.top;
    const heightPercentage = height / area.rowCount;
    const seatMargin = config.seats.margin;
    let widthAdjustment = seatMargin * 2;
    if (type === SeatType.SofaLeft || type === SeatType.SofaRight) {
        widthAdjustment = seatMargin * 1;
    }
    else if (type === SeatType.SofaMiddle) {
        widthAdjustment = 0;
    }
    return {
        width: getMapDimension(widthPercentage, scaleFactor) - widthAdjustment,
        height: getMapDimension(heightPercentage, scaleFactor) - seatMargin * 2
    };
}
/**
 * Returns the coordinates of a seat in SVG units.
 */
function getSeatCoordinates(area, type, position, scaleFactor, config) {
    const invertSeatMap = config.screen.position === SeatPickerScreenPosition.Top;
    const columnIndex = invertSeatMap ? area.columnCount - position.columnNumber : position.columnNumber - 1;
    const rowIndex = invertSeatMap ? area.rowCount - position.rowNumber : position.rowNumber - 1;
    const areaWidth = area.boundary.right - area.boundary.left;
    const areaHeight = area.boundary.bottom - area.boundary.top;
    const leftPercentage = (columnIndex * areaWidth) / area.columnCount;
    const topPercentage = (rowIndex * areaHeight) / area.rowCount;
    let leftAdjustment = config.seats.margin;
    const adjustedSofaSide = invertSeatMap ? SeatType.SofaRight : SeatType.SofaLeft;
    if (type === SeatType.SofaMiddle || type === adjustedSofaSide) {
        leftAdjustment = 0;
    }
    return {
        x: getMapDimension(leftPercentage, scaleFactor) + leftAdjustment,
        y: getMapDimension(topPercentage, scaleFactor) + config.seats.margin
    };
}
